import { memo } from "react";
import { MdOutlineShoppingCart } from "react-icons/md";
import { AppLink } from "../../shared";
import { getFirmTypeStyle } from "../../../utils/firmTypeStyles";

/**
 * Molekül: sipariş vermeyen firmada üst firma hatırlatması (#272, #367).
 * Kural (dashboard-alerts.md v1.7): bayinin kendi faturası ağını kapsar, ana
 * firmanınki kapsamaz — ana firma alt firmaya kota göndermelidir.
 *  - Üstü bayi      → "Bayi <bayi> sipariş vermedi"
 *  - Üstü ana firma → "<ana firma> kota göndermedi"
 *  - Üstü yok       → çizilmez (firma zaten bu listede; tekrar yazılmaz)
 * Üst firma adı tipine göre renkli ve tıklanınca o firmaya gider.
 */
function OrderResponsibleNote({ responsible, onNavigate, className = "" }) {
  if (!responsible?.firmName) return null;
  const isDealer = responsible.firmType === "dealer";
  const style = getFirmTypeStyle(responsible.firmType || "customer");
  const name = responsible._id ? (
    <AppLink
      to={`/Anasayfa/Firma/${responsible._id}`}
      state={{ fromPage: "Anasayfa/Dashboard" }}
      onClick={onNavigate}
      title={`${responsible.firmName} firmasına git`}
      className={`font-Bold underline-offset-2 hover:underline ${style.text}`}
    >
      {responsible.firmName}
    </AppLink>
  ) : (
    <span className={`font-Bold ${style.text}`}>{responsible.firmName}</span>
  );
  return (
    <p className={`flex items-start gap-1.5 text-xs text-gray-600 ${className}`}>
      <MdOutlineShoppingCart className="mt-0.5 h-3.5 w-3.5 shrink-0 text-orange-400" />
      {isDealer ? (
        <span>Bayi {name} sipariş vermedi</span>
      ) : (
        <span>{name} kota göndermedi</span>
      )}
    </p>
  );
}

export default memo(OrderResponsibleNote);
